// Formatting shared by the satellite pages.

export const isOk = (res) => res && res.status >= 200 && res.status < 300;

// Name a satellite is shown by: its name, else the host name or the IP the agent reported.
export function satelliteName(vm, satellite) {
  if (!satellite) return "";
  return satellite.name || satellite.hostname || satellite.ip || vm.$t("satellites.unnamed");
}

// Plural form by the CLDR rules of the current locale: the message is an object with "one", "few", "many", "other".
export function plural(vm, key, count, params = {}) {
  let category = "other";
  try {
    category = new Intl.PluralRules(vm.$i18n.locale).select(count);
  } catch (e) {
    // Unknown locale: "other"
  }
  const path = vm.$te(`${key}.${category}`) ? `${key}.${category}` : `${key}.other`;
  return vm.$t(path, { count, ...params });
}

export function messagesOf(value) {
  return (Array.isArray(value) ? value : value ? [value] : []).join(" ");
}

// Methods for the templates of the satellite pages.
export const formatMixin = {
  methods: {
    pl(key, count, params) {
      return plural(this, key, count, params);
    },
    satName(satellite) {
      return satelliteName(this, satellite);
    },
    formatDate(value) {
      return value ? this.$moment(value).format("YYYY-MM-DD HH:mm") : "—";
    },
    formatDay(value) {
      return value ? this.$moment(value).format("YYYY-MM-DD") : "—";
    },
    showError(res) {
      this.$alert({ type: "error", title: (res && res.message) || this.$t("server_error") });
    },
  },
};
